export default "__VITE_ASSET__209c613a__"